import React from 'react';
import { stats } from '../data/content';
export function StatsBar() {
  return <section className="w-full border-y border-ink/10 bg-white py-10 sm:py-14" data-id="element-173" data-mp="1tarjq9bipqkw">
      <div className="mx-auto max-w-6xl px-5" data-id="element-174" data-mp="1t8niy08x17ou">
        <h2 className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-175" data-mp="1oac9hqmj8z75">
          I Numeri Non Mentono
        </h2>
        <dl className="mt-8 grid grid-cols-2 gap-y-8 md:grid-cols-4 md:gap-y-0" data-id="element-176" data-mp="1jeeqtdnsrgr7">
          {stats.map((stat, index) => <div key={stat.label} className={`px-4 text-center ${index > 0 ? 'md:border-l md:border-ink/10' : ''}`} data-id="element-177" data-mp="19mr6rxtkl1zr" data-mpi={index}>
              <dt className="sr-only" data-id="element-178" data-mp="10lt17b3hgmf2">{stat.label}</dt>
              <dd data-id="element-179" data-mp="10n46xggho48t">
                <span className="block font-display text-3xl font-black text-ink sm:text-4xl" data-id="element-180" data-mp="10nnjehnde0fg">
                  {stat.value}
                </span>
                <span className="mt-1 block text-[10px] font-bold uppercase tracking-[0.16em] text-ink/50 sm:text-xs" data-id="element-181" data-mp="qn4xzig5qbvf">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}